import React , {Component} from 'react'
import {BrowserRouter, Route, Link,Switch} from 'react-router-dom'
import En from './components/En'
import Fr from './components/Fr'
import ContactEn from './components/ContactEn'
import ContactFr from './components/ContactFr'
export default class App extends Component{
  render(){
    return(

        <BrowserRouter>
        	<Switch>
        		<Route exact path = "/accident-recovery-expert" component = {En} />
        		<Route exact path = "/expert-en-sinistre" component = {Fr} />
       			<Route exact path = "/accident-recovery-expert/contact" component = {ContactEn}></Route>
        		<Route exact path = "/expert-en-sinistre/contact" component = {ContactFr} />
        		<Route exact path = "*" component = {En} />
        	</Switch>
        </BrowserRouter>


      )
  }
}


// WEBPACK FOOTER //
// ./src/App.js